import request from '@/utils/http'



export function getCode_api(data){
    return request({
    url:`/v4/user/login?code=${data.code}`,
    method:'post',

})
}

export function getMember_api(data){
  return request({
  url:`/v12/user/member?member_id=${data}`,
  method:'get',

})
}

export function getuser_api(){
  return request({
  url:`/v4/user/user`,
  method:'get',
})
}

// 验证码
export function getSmsCode(data){
  let opt = {
        method: 'POST',
        url: `/v4/common/mobileCode`,
        data,
      };
  
  return request(opt);
}

// 判断用户
// 验证码
export function getApplyUser(data){
  let opt = {
        method: 'get',
        url: `/v4/user/member`,
        data,
      };
  
  return request(opt);
}

// 判断购购
export function setjudge(data){
  let opt = {
        method: 'post',
        url: `/v4/user/member`,
        data,
      };
  
  return request(opt);
}


// 获取七牛云凭证
export function getImgToken(params){
  let opt = {
        method: 'GET',
        url: `/v4/common/uploadToken`,
        params,
      };
  
  return request(opt);
}

// 上传图片
export function uploadImg(data){
  let opt = {
        method: 'POST',
        url: `https://up-z2.qiniup.com/`,
        data,
      };
  
  return request(opt);
}

export function uploadImg1(data,url){
  let opt = {
        method: 'POST',
        url: `https://up-z2.qiniup.com/putb64/${url}`,
        data,
      };
  
  return request(opt);
}

// 配置信息
export function configSetting(data){
  let opt = {
        method: 'POST',
        url: `/v4/common/config`,
        data,
      };
  
  return request(opt);
}

// 配置信息
export function orderPay(data){
  let opt = {
        method: 'POST',
        url: `/v4/user/apply`,
        data,
      };
  
  return request(opt);
}

// 修改信息
export function detailsInfo(data,id){
  let opt = {
        method: 'put',
        url: `/v4/user/apply/`+id,
        data,
      };
  
  return request(opt);
}

// 修改信息
export function auditList(data){
  let opt = {
        method: 'get',
        url: `/v4/user/apply`,
        data,
      };
  
  return request(opt);
}

// 修改信息
export function getDetails(id){
  let opt = {
        method: 'get',
        url: `/v4/user/apply/`+id,

      };
  
  return request(opt);
}

// 修改信息
export function getConfig(data){
  let opt = {
        method: 'get',
        url: `/v4/common/jsSdkConfig`,
        params:data
      };
  
  return request(opt);
}

// 修改信息
export function getSetting(){
  let opt = {
        method: 'get',
        url: `/v5/user/shareholderApply`,

      };
  
  return request(opt);
}

// 修改信息
export function shareholderApply_api(data){
  let opt = {
        method: 'post',
        url: `/v5/user/shareholderApply`,
        data
      };
  
  return request(opt);
}

export function detailShareholderApply_api(data,id){
  let opt = {
        method: 'put',
        url: `/v5/user/shareholderApply/${id}`,
        data
      };
  
  return request(opt);
}

// 修改信息
export function getUserInfo_api(){
  let opt = {
        method: 'get',
        url: `/v5/user/activate`,
      };
  
  return request(opt);
}

// 修改信息
export function getShareDetail_api(id){
  let opt = {
        method: 'get',
        url: `/v5/user/shareholderApply/`+id,
      };
  
  return request(opt);
}

// 转让详情
export function putOrder_api(id){
  let opt = {
        method: 'get',
        url: `/v7/user/sharesTrade/`+id,
      };
  
  return request(opt);
}

// 修改信息
export function getSharePay_api(id,data){
  let opt = {
        method: 'put',
        url: `/v5/user/shareholderOnlinePayment/`+id,
        data
      };
  
  return request(opt);
}

// 兑换
export function putSharePay_api(id,data){
  let opt = {
        method: 'put',
        url: `/v6/user/sharesApply/`+id,
        data
      };
  
  return request(opt);
}

// 修改信息
export function getShipments_api(data){
  let opt = {
        method: 'get',
        url: `/v5/user/shipments`,
        data
      };
  
  return request(opt);
}

// 修改信息
export function putActivate_api(data){
  let opt = {
        method: 'post',
        url: `/v5/user/activate`,
        data
      };
  
  return request(opt);
}

export function SellingDeal_api(id){
  let opt = {
        method: 'get',
        url: '/v7/user/sharesSales/'+id,
      };
  
  return request(opt);
}

//贡献值分布
export function getContributionExchangeShare_api(){
  let opt = {
        method: 'get',
        url: 'v12/user/ContributionExchangeShare',

      };
  
  return request(opt);
}

//贡献值结算
export function updateExchangeShare_api(data){
  let opt = {
        method: 'post',
        url: 'v12/user/contributionExchangeShare/checkoutContributionExchangeShare',
        data:data
      };
  
  return request(opt);
}

//贡献值兑换
export function ContributionExchangeSharePost_api(data){
  let opt = {
        method: 'post',
        url: 'v12/user/contributionExchangeShare/contributionExchangeShare',
        data:data
      };
  
  return request(opt);
}


//单独成为会员
export function ContributionShareholderRenew_api(data){
  let opt = {
        method: 'post',
        url: '/v12/user/shareholderRenew',
        data:data
      };
  
  return request(opt);
}


//订单列表
export function ContributionExchangeShareOrder_api(data){
  let opt = {
        method: 'get',
        url: '/v12/user/ContributionExchangeShare/1/edit',
        params:data
      };
  
  return request(opt);
}

//合约续签
export function shareholderRenew(data){
  let opt = {
        method: 'post',
        url: '/v12/user/shareholderRenew',
        data:data
      };
  
  return request(opt);
}


//门店贡献值
export function Contribution_api(data){
  let opt = {
        method: 'get',
        url: 'v12/user/Contribution',
        params:data
      };
  
  return request(opt);
}

//门店贡献值
export function readContribution_api(data){
  let opt = {
        method: 'get',
        url: 'v6/user/Contract/read',
        params:data
      };
  
  return request(opt);
}

//合同修复
export function detailsPutContent(data){
  let opt = {
        method: 'post',
        url: 'v12/user/User/updateContract',
        data:data
      };
  
  return request(opt);
}




